import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import usePrivate from '@afosto/auth-react/usePrivate';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import { useAppState } from '@afosto/app-components-react/AppProvider';
import { useHistory } from 'react-router-dom';
import ShipmentsGrid from '../../components/ShipmentsGrid';
import SwitchLocationsDialog from '../../components/SwitchLocationsDialog';
import Page from '@afosto/app-components-react/Page';
import translations from './translations';

const Shipments = () => {
  usePrivate();
  const [hasPermissions, UnauthorizedComponent] = usePermissions([
    'lcs:shipments:read',
    'lcs:locations:read',
    'rel:contacts:read',
  ]);

  const history = useHistory();
  const intl = useIntl();
  const sessionManager = useSessionManager();
  const { settings = {} } = useAppState();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const showCreateButton =
    !isMobile || (isMobile && settings?.shipments?.show_create_shipment_button_mobile);
  const [showSwitchLocationsDialog, setShowSwitchLocationsDialog] = useState(false);

  if (!hasPermissions()) {
    return (
      <Page title={intl.formatMessage(translations.title)} fullWidth>
        <UnauthorizedComponent />
      </Page>
    );
  }

  return (
    <>
      <Page
        title={intl.formatMessage(translations.title)}
        primaryAction={
          sessionManager &&
          sessionManager.hasPermissions(['lcs:shipments:write']) &&
          showCreateButton
            ? {
                text: intl.formatMessage(translations.create.button),
                action: () => history.push('/shipments/new'),
              }
            : null
        }
        secondaryActions={[
          {
            key: 'switch',
            text: intl.formatMessage(translations.secondaryActions.switchLocations),
            action: () => {
              setShowSwitchLocationsDialog(true);
            },
            shortCut: true,
            icon: ['fal', 'exchange'],
          },
        ]}
        fullWidth
      >
        <ShipmentsGrid showSwitchLocationsDialog={showSwitchLocationsDialog} />
      </Page>
      <SwitchLocationsDialog
        isOpen={showSwitchLocationsDialog}
        onCancel={() => setShowSwitchLocationsDialog(false)}
        onSwitch={() => setShowSwitchLocationsDialog(false)}
      />
    </>
  );
};

export default Shipments;
